import React from 'react';
import { useTranslation } from 'react-i18next';

import { config } from '~/config';

import * as S from './UpgradeToUnlock.styles';

export const UpgradeToUnlock = () => {
  const { t } = useTranslation('widget');

  const handleContactSales = () =>
    window.open(config.supportUrl, '_blank', 'noopener,noreferrer');

  return (
    <S.Container data-testid="upgrade-to-unlock">
      <S.ImageContainer>
        <S.Image src="/app/static/images/illustrations/success.png" />
      </S.ImageContainer>
      <S.Title>{t('widget:upgradeToUnlock.title')}</S.Title>
      <S.StyledButton
        variant="primary"
        size="large"
        onClick={handleContactSales}
        label={t('widget:upgradeToUnlock.contactSales')}
      />
    </S.Container>
  );
};
